﻿(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Util = {};
    
    function changeLanguage() {
        $(document).on("click", ".language-switcher a", function (e) {
            M2.Util.config.language = $(this).data("language");
        });     
    }
    function disableSubmission(btn) {
        // Disable the buttons immediatly
        $(btn).addClass('disabled').attr('disabled', 'disabled');
    }
    function enableSubmission(btn) {
        // Re-enable the button as we've found suggestions
        $(btn).removeClass('disabled').removeAttr('disabled');
    }

    M2.Util = {
        config: {
            name: "M2 Fundraising Utilities",
            limelightPlayerId: "limelight_player_449876",
            pathToImages: "",
            language: "en",
            groupLabel: "Troop",
            groupNotSelectedText: "Troop not selected",
            awardNotificationHeaderText: "Congratulations!"
        },
        isMobile: {
            Android: function () {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function () {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function () {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function () {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function () {
                return (M2.Util.isMobile.Android() || M2.Util.isMobile.BlackBerry() || M2.Util.isMobile.iOS() || M2.Util.isMobile.Opera() || M2.Util.isMobile.Windows());
            }
        },
        init: function () {
            changeLanguage();
            M2.Util.setSwitches();
            M2.Util.setProgressBar();
            M2.Util.activatePrint();
        },
        setSwitches: function() {
            var elems = Array.prototype.slice.call(document.querySelectorAll('.switch'));
            elems.forEach(function (html) {
                /* global Switchery */
                let switchery;
                if ($(html).is('[readonly]')) {
                    switchery = new Switchery(html, { disabled: true });
                } else {
                    switchery = new Switchery(html);
                }
                //console.log(switchery);
            });
        },
        setjQueryMobile: function () {
            if (M2.Util.isMobile.any()) {
                $(document).trigger('create');
            }
        },
        exists: function (elem) {
            if (elem.length > 0) return true;
        },
        clearSearchBox: function(target, defaultText) {
            $(target).click(function () {
                if ($(this).val() == defaultText) $(this).val('');
            });
        },
        // Set File Uploads
        uploadPhoto: function(elem) {
            var tmpURL = $($(elem).attr("data-url")).val();
            var tmpPreview = $(elem).attr("data-preview");
            var oldImageURL = $(tmpPreview).attr("src");

            $(elem).fineUploader({
                request: {
                    endpoint: tmpURL,
                    inputName: 'File'
                },
                text: {
                    uploadButton: $(elem).html()
                },
                validation: {
                    sizeLimit: 5242880
                }
            }).on('upload', function (id, name) {
                $(tmpPreview).hide().attr("src", M2.Util.config.pathToImages + "loading-bar.gif").addClass("loading");
                $(tmpPreview).fadeIn();
            }).on('complete', function (event, id, fileName, responseJSON) {
                if (responseJSON.success) {
                    $(".qq-upload-list").fadeOut();
                    var randomnumber = Math.floor(Math.random() * 11);
                    $(tmpPreview).hide().delay(400).removeClass("loading").attr("src", responseJSON.viewurl + '&' + randomnumber).fadeIn();
                    M2.Dashboard.refreshToDoList();
                } else if (responseJSON.error) {
                    $(".qq-upload-list").fadeOut();
                    $(tmpPreview).removeClass("loading").attr("src", oldImageURL);
                }
            });
        },
        setProgressBar: function () {

            $(function () {
                $('.goal-thermometer').each(function () {
                    var value = parseInt($(this).data("val"));
                    var maxValue = parseInt($(this).data("total"));
                    $(this).progressbar({ value: value, max: maxValue });
                });
            });
        }, 
        displayLoad: function(target) {
            $(target).html("<div style='text-align: center;'><img src='" + M2.Util.config.pathToImages + "loading-bar.gif' alt='Loading' /></div>");
        },
        addCommas: function(x) {
            return x.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
        },
        successMsg: function(target) {
            if (typeof target === "undefined") target = ".message-area";
            $(target).fadeIn().delay(1800).fadeOut(500);
            //$(target).fadeIn();
        },
        activatePrint: function () {
            $(document).on("click", "a.print-report, .btn.print", function (e) {
                e.preventDefault();
                window.print();
                return false;
            });

            $(document).on("click", "#business-cards-overlay .print", function () {
             window.print();
            });


        },
        submitForm: function (formRef, btnRef) {
            $(formRef).validate();
            if ($(formRef).valid()) {
                disableSubmission(btnRef);
                $(formRef).submit();
            } else {
                enableSubmission(btnRef);
            }
        },
        enableSubmission: function (btn) {
            enableSubmission(btn);
        },
        matchRowHeights: function(target) {
        $(target).matchHeight();
        }
    }
})(jQuery);

$(function () {
    M2.Util.init();
});